"use client";
import "@rc-component/color-picker/assets/index.css";
import React, { useState } from "react";
import RCColorPicker, { Color } from "@rc-component/color-picker";
import { Avatar, Box, Button, IconButton, Menu, Stack } from "@mui/material";

interface IColorPicker {
  value?: string;
  onChange?: (val: string) => void;
}

function ColorPicker({ value = "", onChange }: IColorPicker) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [color, setColor] = useState<Color>(() => {
    return new Color(value);
  });
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteColor = () => {
    setColor(new Color(""));
    onChange?.("");
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        slotProps={{ paper: { sx: { "& .MuiList-root": { py: 0 } } } }}
      >
        <RCColorPicker
          value={color}
          onChangeComplete={(color) => {
            setColor(color);
            onChange?.(color.toHexString());
          }}
        />
        <Stack direction="row" alignItems="center" justifyContent="center">
          <Button onClick={handleDeleteColor}>Xóa bỏ</Button>
        </Stack>
      </Menu>
      {/* Button */}
      <IconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ borderRadius: "10px" }}
      >
        {!!value ? (
          <Box
            sx={{
              width: "30px",
              height: "30px",
              backgroundColor: color.toHexString(),
              borderRadius: "4px",
            }}
          ></Box>
        ) : (
          <Avatar
            src="/colorful.png"
            sx={{ width: "30px", height: "30px" }}
            alt=""
          />
        )}
      </IconButton>
    </>
  );
}

export default ColorPicker;
